export enum CertificateGenerationPoint {
  HomePage = 'HomePage',
  LandingPage = 'LandingPage',
  ReferralPage = 'ReferralPage',
}
